import { NewlyHired, NewlyHiredApiData } from './newlyHired'
import {
    AllowedUpdateActionList,
    CaseStatus,
    CaseStatusApiData,
    Reminder,
    ReminderData,
} from './Case'
import { CaseNote, CaseNoteData } from './CaseNote'

export interface StatusApiData {
    statusId: number
    statusNavn: string
    statusMangler: boolean
    datoKraevet: boolean
}

export class Status {
    statusId = 0

    statusName = ''

    statusMissing = false

    dateRequired = false

    static build(data: StatusApiData): Status {
        const status = new Status()
        status.statusId = data.statusId
        status.statusName = data.statusNavn
        status.statusMissing = data.statusMangler
        status.dateRequired = data.datoKraevet
        return status
    }
}

export interface SagsBehandlingApiData {
    kontaktTilNyansatStatus: StatusApiData | null
    organiseringStatus: StatusApiData | null
    organiseringStatusKanIkkeOpdateres: boolean
    loenindplaceringStatus: StatusApiData | null
    kontaktTilNyansatDato: string | null
}

export class CaseProcessing {
    newlyHiredStatus: Status

    organizationStatus: Status

    organizationStatusCannotBeUpdated = false

    salaryPlacementStatus: Status

    contactNewlyHiredDate: string | null

    static build(data: SagsBehandlingApiData): CaseProcessing {
        const caseProcessing = new CaseProcessing()
        caseProcessing.newlyHiredStatus = Status.build(
            data.kontaktTilNyansatStatus
        )
        caseProcessing.organizationStatus = Status.build(
            data.organiseringStatus
        )
        caseProcessing.organizationStatusCannotBeUpdated =
            data.organiseringStatusKanIkkeOpdateres
        caseProcessing.salaryPlacementStatus = Status.build(
            data.loenindplaceringStatus
        )
        caseProcessing.contactNewlyHiredDate = data.kontaktTilNyansatDato

        return caseProcessing
    }
}

export interface FileApiData {
    titel: string
    extension: string
    fuldeNavn: string
    mimeType: string
    aendringsTid: string
    length: number
    sagsNr: string
}

export class File {
    title = ''

    extension = ''

    fullName = ''

    mimeType = ''

    changeTime = ''

    length = 0

    caseNumber = ''

    static build(data: FileApiData): File {
        const file = new File()
        file.title = data.titel
        file.extension = data.extension
        file.fullName = data.fuldeNavn
        file.mimeType = data.mimeType
        file.changeTime = data.aendringsTid
        file.length = data.length
        file.caseNumber = data.sagsNr
        return file
    }
}

export interface CaseDetailApiData {
    sagsBehandling: SagsBehandlingApiData
    reminderList: ReminderData[]
    notatList: CaseNoteData[]
    filList: FileApiData[]
    flettetSagList: any[] | null
    visAccepterDialog: boolean
    nyansat: NewlyHiredApiData
    sagStatus: CaseStatusApiData
    modtagetDato: string
    fristDato: string
    afsluttetSagsbehandlingsDato: string | null
    lovligOpdateringHandlingList: AllowedUpdateActionList[]
    sagsRegTid: string
    sagsId: string
    sagsNr: string
}

export interface MergedCaseApiData {
    modtagetDato: string
    nyansatteNavn: string
    sagsNr: string
    sagsId: string
    sagsRegTid: string
    sagStatus: CaseStatusApiData
}

export class CaseDetail {
    error: any

    caseProcessing: CaseProcessing

    reminderList: Reminder[] = []

    noteList: CaseNote[] = []

    fileList: File[] = []

    mergedCaseList: MergedCaseApiData[] | null = null

    showAcceptDialog = false

    newlyHired: NewlyHired

    caseStatus: CaseStatus

    receivedDate = ''

    deadlineDate = ''

    caseProcessingEndDate: string | null = null

    allowedUpdateActionList: AllowedUpdateActionList[] = []

    caseRegistrationTime = ''

    caseId = ''

    caseNumber = ''

    isClosed = false

    static build(data: CaseDetailApiData): CaseDetail {
        const caseDetail = new CaseDetail()
        caseDetail.caseProcessing = CaseProcessing.build(data.sagsBehandling)
        caseDetail.reminderList = data.reminderList.map((reminder) =>
            Reminder.build(reminder)
        )
        caseDetail.noteList = data.notatList.map((note) => CaseNote.build(note))
        caseDetail.fileList = data.filList.map((file) => File.build(file))
        caseDetail.mergedCaseList = data.flettetSagList
        caseDetail.showAcceptDialog = data.visAccepterDialog
        caseDetail.newlyHired = NewlyHired.build(data.nyansat)
        caseDetail.caseStatus = CaseStatus.build(data.sagStatus)
        caseDetail.receivedDate = data.modtagetDato
        caseDetail.deadlineDate = data.fristDato
        caseDetail.caseProcessingEndDate = data.afsluttetSagsbehandlingsDato
        caseDetail.allowedUpdateActionList = data.lovligOpdateringHandlingList
        caseDetail.caseRegistrationTime = data.sagsRegTid
        caseDetail.caseId = data.sagsId
        caseDetail.caseNumber = data.sagsNr
        caseDetail.isClosed =
            data.sagStatus.statusType === 'Afsluttet' ||
            data.sagStatus.statusType === 'IkkeTRRelevant'
        return caseDetail
    }
}
